var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { BurnComponent, CouponCardComponent, CouponComponent, HeaderComponent, HistoryComponent, DatetimeComponent, } from "ocm/src/app/components";
import { DevicesComponent } from "ocm/src/app/icons";
import { AdminPage, BurnPage, ConfirmationPage, CouponCardPage, LanguagePage, MountingSettingsPage, QrScannerPage, ScreenSaverPage, SuccessPage, SuccessRedeemPage, RevenueDatePage, LoginPage, ConfigurationsPage, } from "ocm/src/app/pages";
import { DeviceMountingService, ProgramService } from "shared/lib/v2/services";
import { P4mService, UtilsService, ConfigService, ThirdPartyScriptsService } from "shared/lib/common/services";
import { LOCAL_STORAGE } from "shared/lib/common/enums";
import { CONFIGURATION } from "shared/lib/common/constants";
export function setCredentials(p4m, utils) {
    return function () {
        var oldUser = utils.decrypt(localStorage.getItem("email"));
        var oldPassword = utils.decrypt(localStorage.getItem("password"));
        if (oldUser && oldPassword) {
            p4m.setUser(oldUser);
            p4m.setPassword(oldPassword);
        }
    };
}
export function initializeApp(deviceMounting, config, thirdParty, utils, program) {
    var _this = this;
    return function () { return __awaiter(_this, void 0, void 0, function () {
        var res, _a, _b, mountingConfig;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, thirdParty.addThirdPartyScripts()];
                case 1:
                    _c.sent();
                    config.setOrganization(CONFIGURATION.organization);
                    return [4 /*yield*/, config.setConfig(program.getProgramConfig(CONFIGURATION.organization))];
                case 2:
                    _c.sent();
                    return [4 /*yield*/, deviceMounting.getMounting()];
                case 3:
                    res = _c.sent();
                    if (!(res.ok === true)) return [3 /*break*/, 5];
                    _b = (_a = config).setMountingConfig;
                    return [4 /*yield*/, deviceMounting.parseMountingConfigV1ToV2(res.response)];
                case 4:
                    _b.apply(_a, [_c.sent()]);
                    return [3 /*break*/, 6];
                case 5:
                    mountingConfig = JSON.parse(utils.decrypt(localStorage.getItem(LOCAL_STORAGE.MOUNTING_CONFIG)));
                    if (mountingConfig)
                        localStorage.clear();
                    _c.label = 6;
                case 6: return [2 /*return*/];
            }
        });
    }); };
}
var icons = [DevicesComponent];
var modals = [RevenueDatePage, LanguagePage, CouponCardPage, SuccessPage, ConfirmationPage, SuccessRedeemPage];
var components = [CouponComponent, HeaderComponent, BurnComponent, HistoryComponent, CouponCardComponent, DatetimeComponent];
var pages = [
    RevenueDatePage,
    MountingSettingsPage,
    AdminPage,
    ScreenSaverPage,
    SuccessPage,
    BurnPage,
    QrScannerPage,
    LoginPage,
    ConfigurationsPage,
];
var AppModule = /** @class */ (function () {
    function AppModule() {
    }
    return AppModule;
}());
export { AppModule };
